import { render, staticRenderFns } from "./FiltersValuesAdd.vue?vue&type=template&id=67894e52"
import script from "./FiltersValuesAdd.vue?vue&type=script&lang=js"
export * from "./FiltersValuesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports